var _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _g3, _path8, _g4, _path9, _path10, _path11, _g5, _path12, _path13, _path14, _path15, _path16, _path17, _g6, _path18, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevelopement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 236,
    viewBox: "0 0 207 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter0_f_3085_1217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.162 17.6709L189.989 46.4478L189.96 165.783L140.133 137.006L140.162 17.6709Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.768 4.60596L194.386 38.4595L194.351 178.847L135.734 144.994L135.768 4.60596Z",
    fill: "url(#paint0_radial_3085_1217)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.097 45.457L204.71 72.3821V85.2787L158.097 58.3536V45.457Z",
    fill: "url(#paint1_linear_3085_1217)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.006 58.7993L187.835 84.6954V104.761L143.006 78.8645V58.7993Z",
    fill: "url(#paint2_linear_3085_1217)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.971 87.4731L187.835 113.369V118.034L142.971 92.1722V87.4731Z",
    fill: "url(#paint3_linear_3085_1217)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M142.972 95.9121L181.765 118.31V122.974L142.972 100.577V95.9121Z",
    fill: "url(#paint4_linear_3085_1217)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M135.769 4.60596L194.387 38.4595V57.2899L135.769 23.4364V4.60596Z",
    fill: "url(#paint5_radial_3085_1217)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3085_1217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.837 21.6926C146.393 22.7918 147.086 23.5507 147.673 23.8978C147.895 24.0219 148.03 24.0468 148.081 24.0516C148.152 23.971 148.415 23.5979 148.415 22.6134C148.415 21.5487 148.099 20.3207 147.549 19.2316C146.987 18.118 146.295 17.3706 145.725 17.0477C145.496 16.9183 145.358 16.8926 145.306 16.8878C145.235 16.9684 144.972 17.3415 144.972 18.326C144.972 19.3892 145.287 20.6077 145.837 21.6926Z",
    stroke: "white",
    strokeWidth: 4
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M145.837 21.6926C146.393 22.7918 147.086 23.5507 147.673 23.8978C147.895 24.0219 148.03 24.0468 148.081 24.0516C148.152 23.971 148.415 23.5979 148.415 22.6134C148.415 21.5487 148.099 20.3207 147.549 19.2316C146.987 18.118 146.295 17.3706 145.725 17.0477C145.496 16.9183 145.358 16.8926 145.306 16.8878C145.235 16.9684 144.972 17.3415 144.972 18.326C144.972 19.3892 145.287 20.6077 145.837 21.6926Z",
    stroke: "white",
    strokeWidth: 4
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.57,
    filter: "url(#filter2_f_3085_1217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.516 138.163C150.626 136.485 148.533 136.44 147.236 138.027C145.939 139.591 145.302 142.243 145.302 145.983V166.136C145.302 169.967 144.938 173.141 144.233 175.657C143.527 178.264 142.321 180.123 140.66 181.211C139.045 182.322 136.861 182.617 134.085 182.096C131.377 181.597 127.987 180.191 123.937 177.856L122.003 176.746V160.877L124.415 162.26C127.304 163.937 129.238 164.141 130.217 162.917C131.241 161.739 131.764 159.268 131.764 155.527V137.777C131.764 133.153 132.219 129.503 133.129 126.805C134.039 124.108 135.837 122.407 138.544 121.637C135.837 117.76 134.039 113.974 133.129 110.257C132.219 106.539 131.787 102.368 131.787 97.7432V79.9932C131.787 76.2528 131.263 73.2151 130.24 70.8348C129.284 68.4999 127.35 66.505 124.438 64.8275L122.026 63.4447V47.5762L123.96 48.687C128.01 51.0219 131.4 53.4928 134.108 56.1225C136.883 58.7748 139.068 61.6084 140.683 64.5781C142.367 67.5931 143.55 70.8122 144.255 74.2352C144.961 77.5676 145.325 81.172 145.325 84.9804V105.133C145.325 108.874 145.962 112.274 147.259 115.312C148.556 118.372 150.649 120.73 153.539 122.385L153.516 138.163Z",
    stroke: "white",
    strokeWidth: 3
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M155.284 140.768C152.07 138.902 149.742 138.851 148.3 140.616C146.857 142.356 146.148 145.306 146.148 149.467V171.882C146.148 176.143 145.743 179.673 144.959 182.472C144.174 185.372 142.833 187.439 140.986 188.65C139.189 189.885 136.759 190.213 133.672 189.633C130.66 189.078 126.889 187.515 122.385 184.918L120.233 183.682V166.032L122.916 167.57C126.13 169.436 128.281 169.663 129.369 168.302C130.508 166.991 131.09 164.242 131.09 160.082V140.339C131.09 135.195 131.597 131.136 132.609 128.135C133.621 125.135 135.62 123.244 138.632 122.386C135.62 118.075 133.621 113.864 132.609 109.729C131.597 105.594 131.116 100.954 131.116 95.8105V76.0677C131.116 71.9073 130.534 68.5286 129.395 65.8811C128.332 63.284 126.181 61.0652 122.941 59.1993L120.259 57.6613V40.0112L122.41 41.2467C126.915 43.8438 130.685 46.5922 133.697 49.517C136.785 52.4671 139.214 55.6189 141.011 58.922C142.884 62.2755 144.2 65.8559 144.984 69.6633C145.769 73.3698 146.174 77.3789 146.174 81.6149V104.03C146.174 108.191 146.882 111.973 148.325 115.352C149.767 118.756 152.096 121.378 155.31 123.218L155.284 140.768Z",
    fill: "url(#paint6_linear_3085_1217)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.57,
    filter: "url(#filter3_f_3085_1217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.959 77.7436C77.9357 79.4717 80.0921 79.5184 81.4282 77.8838C82.7642 76.2724 83.4205 73.5402 83.4205 69.687V48.9264C83.4205 44.9798 83.7955 41.7105 84.5221 39.1183C85.2487 36.4328 86.4441 34.4945 88.1083 33.3502C89.8428 32.2293 92.0929 31.9257 94.8822 32.4395C97.7417 32.9766 101.258 34.4478 105.43 36.8531L107.422 37.9974V54.3443L104.938 52.9198C101.961 51.1917 99.9216 50.9581 98.8668 52.1725C97.8824 53.4335 97.3667 55.979 97.3667 59.8321V78.1173C97.3667 82.8812 96.8979 86.641 95.9604 89.42C95.0228 92.1756 93.1711 93.9504 90.3819 94.7444C93.1711 98.7377 95.0228 102.638 95.9604 106.467C96.8979 110.297 97.3433 114.594 97.3433 119.358V137.643C97.3433 141.496 97.8355 144.626 98.8434 147.031C99.8981 149.483 101.937 151.561 104.914 153.266L107.399 154.691V171.038L105.406 169.893C101.234 167.488 97.7183 164.919 94.8587 162.187C92.0695 159.478 89.8193 156.582 88.0849 153.476C86.4207 150.417 85.2253 147.124 84.4987 143.575C83.7721 140.142 83.397 136.429 83.397 132.506V111.745C83.397 107.892 82.7408 104.389 81.4047 101.26C80.0687 98.1072 77.9123 95.6785 74.9355 93.9737L74.959 77.7436Z",
    stroke: "white",
    strokeWidth: 3
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M73.6669 75.8404C76.881 77.7062 79.2093 77.7567 80.6518 75.9917C82.0943 74.2519 82.803 71.3018 82.803 67.1414V44.7259C82.803 40.4647 83.2079 36.9347 83.9924 34.1359C84.7769 31.2362 86.0676 29.1435 87.8645 27.908C89.7372 26.6977 92.1668 26.3699 95.1784 26.9246C98.2659 27.5045 102.062 29.093 106.567 31.6901L108.718 32.9256V50.5756L106.035 49.0376C102.821 47.1717 100.619 46.9195 99.4807 48.2307C98.4177 49.5923 97.861 52.3406 97.861 56.501V76.2438C97.861 81.3875 97.3548 85.447 96.3425 88.4475C95.3302 91.4228 93.3309 93.3391 90.3193 94.1964C93.3309 98.508 95.3302 102.719 96.3425 106.854C97.3548 110.989 97.8357 115.629 97.8357 120.772V140.515C97.8357 144.675 98.3671 148.054 99.4553 150.651C100.594 153.299 102.796 155.543 106.01 157.383L108.693 158.922V176.572L106.541 175.336C102.037 172.739 98.2406 169.965 95.1531 167.015C92.1414 164.09 89.7119 160.964 87.8392 157.61C86.0423 154.307 84.7516 150.752 83.9671 146.92C83.1826 143.213 82.7776 139.204 82.7776 134.968V112.552C82.7776 108.392 82.069 104.61 80.6265 101.231C79.184 97.8273 76.8557 95.205 73.6416 93.3643L73.6669 75.8404Z",
    fill: "url(#paint7_linear_3085_1217)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M145.162 148.333C141.948 146.467 139.62 146.416 138.177 148.181C136.735 149.921 136.026 152.871 136.026 157.032V179.447C136.026 183.708 135.621 187.238 134.837 190.037C134.052 192.937 132.711 195.004 130.864 196.215C129.067 197.45 126.637 197.778 123.55 197.198C120.538 196.643 116.767 195.08 112.262 192.483L110.111 191.247V173.597L112.794 175.135C116.008 177.001 118.159 177.228 119.247 175.867C120.386 174.555 120.968 171.807 120.968 167.647V147.904C120.968 142.76 121.474 138.701 122.487 135.7C123.499 132.7 125.498 130.809 128.51 129.951C125.498 125.64 123.499 121.429 122.487 117.294C121.474 113.159 120.994 108.519 120.994 103.375V83.6326C120.994 79.4723 120.412 76.0936 119.273 73.4461C118.21 70.849 116.059 68.6301 112.819 66.7643L110.137 65.2262V47.5762L112.288 48.8117C116.793 51.4087 120.563 54.1571 123.575 57.082C126.662 60.032 129.092 63.1838 130.889 66.4869C132.762 69.8404 134.078 73.4208 134.862 77.2282C135.647 80.9347 136.052 84.9438 136.052 89.1798V111.595C136.052 115.756 136.76 119.538 138.203 122.917C139.645 126.32 141.974 128.943 145.188 130.783L145.162 148.333Z",
    fill: "url(#paint8_radial_3085_1217)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M63.5448 83.4058C66.7589 85.2717 69.0872 85.3221 70.5297 83.5571C71.9723 81.8173 72.6809 78.8672 72.6809 74.7069V52.2913C72.6809 48.0301 73.0858 44.5001 73.8703 41.7013C74.6549 38.8017 75.9456 36.7089 77.7424 35.4734C79.6152 34.2631 82.0447 33.9353 85.0563 34.49C88.1438 35.07 91.94 36.6585 96.4447 39.2555L98.5959 40.491V58.1411L95.9132 56.603C92.6992 54.7371 90.4974 54.485 89.3586 55.7961C88.2957 57.1577 87.7389 59.9061 87.7389 64.0664V83.8092C87.7389 88.953 87.2327 93.0125 86.2204 96.013C85.2081 98.9883 83.2088 100.905 80.1972 101.762C83.2088 106.073 85.2081 110.284 86.2204 114.419C87.2327 118.555 87.7136 123.194 87.7136 128.338V148.081C87.7136 152.241 88.245 155.62 89.3333 158.217C90.4721 160.864 92.6739 163.108 95.8879 164.949L98.5705 166.487V184.137L96.4194 182.902C91.9146 180.304 88.1185 177.531 85.031 174.581C82.0194 171.656 79.5899 168.529 77.7171 165.176C75.9203 161.873 74.6296 158.318 73.845 154.485C73.0605 150.778 72.6556 146.769 72.6556 142.533V120.118C72.6556 115.957 71.947 112.175 70.5044 108.797C69.0619 105.393 66.7336 102.77 63.5195 100.93L63.5448 83.4058Z",
    fill: "url(#paint9_radial_3085_1217)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_3085_1217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0268 87.6606L76.9609 118.779V218.699L23.0268 187.58V87.6606Z",
    fill: "white"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M16.8901 72.752L83.0967 110.951V233.607L16.8901 195.408V72.752Z",
    fill: "url(#paint10_radial_3085_1217)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3684 144.236L76.5391 174.929V180.302L23.3684 149.648V144.236Z",
    fill: "url(#paint11_linear_3085_1217)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0815 158.197L72.7861 184.585V189.957L27.0815 163.569V158.197Z",
    fill: "url(#paint12_linear_3085_1217)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3994 180.121L0.339249 153.536V167.243L46.3994 193.828V180.121Z",
    fill: "url(#paint13_linear_3085_1217)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M57.499 120.986C57.499 126.911 54.0623 129.716 49.8355 127.266C45.6087 124.778 42.172 117.983 42.172 112.018C42.172 106.093 45.6087 103.288 49.8355 105.737C54.0623 108.226 57.499 115.06 57.499 120.986Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M57.499 120.986C57.499 126.911 54.0623 129.716 49.8355 127.266C45.6087 124.778 42.172 117.983 42.172 112.018C42.172 106.093 45.6087 103.288 49.8355 105.737C54.0623 108.226 57.499 115.06 57.499 120.986Z",
    fill: "url(#paint14_linear_3085_1217)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_3085_1217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.844 125.54C52.434 126.459 53.406 126.194 53.9855 125.719C54.7219 125.117 55.499 123.642 55.499 120.986C55.499 118.383 54.7362 115.499 53.4653 112.971C52.1843 110.423 50.4972 108.45 48.8265 107.464C47.2366 106.545 46.2646 106.811 45.6852 107.285C44.9487 107.888 44.1716 109.363 44.1716 112.019C44.1716 114.642 44.935 117.526 46.2047 120.047C47.4842 122.588 49.1709 124.552 50.844 125.54Z",
    stroke: "white",
    strokeWidth: 4
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8348 132.046C43.0008 128.056 37.352 131.809 36.3644 140.381C36.2064 141.882 37.3125 143.858 38.695 144.648L60.9746 157.683C62.3572 158.474 63.4633 157.841 63.3052 156.143C62.3177 146.346 56.6688 136.036 49.8348 132.046Z",
    fill: "url(#paint15_linear_3085_1217)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3085_1217",
    x: 123.133,
    y: 0.670898,
    width: 83.8564,
    height: 182.112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    result: "effect1_foregroundBlur_3085_1217"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3085_1217",
    x: 138.508,
    y: 10.4233,
    width: 16.3702,
    height: 20.0929,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.23172,
    result: "effect1_foregroundBlur_3085_1217"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3085_1217",
    x: 108.103,
    y: 32.5849,
    width: 59.3371,
    height: 163.66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.2,
    result: "effect1_foregroundBlur_3085_1217"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3085_1217",
    x: 61.0346,
    y: 18.2978,
    width: 60.2873,
    height: 167.731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.2,
    result: "effect1_foregroundBlur_3085_1217"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_3085_1217",
    x: 6.02637,
    y: 70.6606,
    width: 87.9346,
    height: 165.038,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    result: "effect1_foregroundBlur_3085_1217"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_3085_1217",
    x: 37.7084,
    y: 100.389,
    width: 24.254,
    height: 32.2272,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.23172,
    result: "effect1_foregroundBlur_3085_1217"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3085_1217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(165.06 156.629) rotate(-90) scale(131.038 44.1091)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#558CF9",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7C4FF",
    stopOpacity: 0.32
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3085_1217",
    x1: 204.71,
    y1: 79.8544,
    x2: 158.097,
    y2: 54.1918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7C4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3085_1217",
    x1: 165.42,
    y1: 58.7993,
    x2: 165.42,
    y2: 104.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3085_1217",
    x1: 165.403,
    y1: 87.4731,
    x2: 165.403,
    y2: 118.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3085_1217",
    x1: 162.368,
    y1: 95.9121,
    x2: 162.368,
    y2: 122.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3085_1217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(194.387 47.9777) rotate(-151.167) scale(66.9132 74.4496)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#558CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7C4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3085_1217",
    x1: 137.772,
    y1: 40.0112,
    x2: 137.772,
    y2: 189.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3085_1217",
    x1: 91.1798,
    y1: 26.6631,
    x2: 91.1798,
    y2: 176.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3085_1217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.111 170.98) rotate(-69.0916) scale(98.2873 86.2945)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#558CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7C4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_3085_1217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.5195 157.64) rotate(-69.0927) scale(98.2924 86.2951)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#558CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7C4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_3085_1217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.9934 213.096) rotate(-90) scale(120.971 49.7905)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3085_1217",
    x1: 49.9537,
    y1: 144.236,
    x2: 49.9537,
    y2: 180.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3085_1217",
    x1: 49.9338,
    y1: 158.197,
    x2: 49.9338,
    y2: 189.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3085_1217",
    x1: 23.3693,
    y1: 153.536,
    x2: 23.3693,
    y2: 193.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3085_1217",
    x1: 49.8355,
    y1: 104.852,
    x2: 49.8355,
    y2: 128.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3085_1217",
    x1: 49.8348,
    y1: 130.45,
    x2: 49.8348,
    y2: 158.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopement);
export default __webpack_public_path__ + "static/media/Developement.e034664840ea112293a9952d8155a74a.svg";
export { ForwardRef as ReactComponent };